export default "__VITE_ASSET__qfAfkQFd__"